import { Helmet } from "react-helmet-async";

const AGB = () => {
  return (
    <>
      <Helmet>
        <title>AGB - Allgemeine Geschäftsbedingungen - EIGENHEIMVERRENTUNG</title>
        <meta name="description" content="Allgemeine Geschäftsbedingungen von EIGENHEIMVERRENTUNG für Beratungsleistungen zur Immobilienverrentung, Leibrente und weitere Finanzdienstleistungen." />
        <meta name="keywords" content="agb, geschäftsbedingungen, vertragsbedingungen, eigenheimverrentung, beratung, immobilien" />
        
        <meta name="robots" content="noindex, follow" />
        <meta name="googlebot" content="noindex, follow" />
      </Helmet>
      
      <div className="min-h-screen bg-gradient-to-br from-background to-muted/20">
        <div className="container mx-auto px-4 py-16">
          <div className="max-w-4xl mx-auto">
            <header className="text-center mb-12">
              <h1 className="text-4xl md:text-5xl font-bold text-primary mb-4">
                Allgemeine Geschäftsbedingungen
              </h1>
              <div className="w-24 h-1 bg-accent mx-auto rounded-full"></div>
            </header>

            <div className="bg-card rounded-2xl shadow-lg border p-8 md:p-12 space-y-8">
              <div className="space-y-8 text-foreground">
                
                <section>
                  <h2 className="text-2xl font-semibold mb-4 text-primary">§ 1 Geltungsbereich</h2>
                  <div className="space-y-4 text-muted-foreground">
                    <p>
                      <strong>1.1</strong> Die nachstehenden Allgemeinen Geschäftsbedingungen (AGB) gelten für alle Beratungsleistungen der RPI GmbH, nachfolgend "Berater" genannt, gegenüber ihrem Vertragspartner, nachfolgend "Auftraggeber" genannt.
                    </p>
                    <p>
                      <strong>1.2</strong> Der Berater erbringt Dienstleistungen auf dem Gebiet der Immobilienberatung, insbesondere in den Bereichen Immobilienverrentung, Leibrente, Teilverkauf, Nießbrauchrecht, Wohnrecht und Seniorenfinanzierung.
                    </p>
                    <p>
                      <strong>1.3</strong> Abweichende Allgemeine Geschäftsbedingungen des Auftraggebers werden nicht anerkannt, es sei denn, der Berater stimmt ihrer Geltung ausdrücklich schriftlich zu.
                    </p>
                  </div>
                </section>

                <section>
                  <h2 className="text-2xl font-semibold mb-4 text-primary">§ 2 Vertragsschluss</h2>
                  <div className="space-y-4 text-muted-foreground">
                    <p>
                      <strong>2.1</strong> Angebote des Beraters sind freibleibend und unverbindlich, sofern sie nicht ausdrücklich als verbindlich bezeichnet werden.
                    </p>
                    <p>
                      <strong>2.2</strong> Ein Beratungsvertrag kommt durch die schriftliche Bestätigung des Beraters oder durch die Aufnahme der Beratungstätigkeit zustande.
                    </p>
                    <p>
                      <strong>2.3</strong> Die Erstberatung erfolgt grundsätzlich kostenlos und unverbindlich. Umfangreichere Beratungsleistungen werden gesondert vereinbart.
                    </p>
                  </div>
                </section>

                <section>
                  <h2 className="text-2xl font-semibold mb-4 text-primary">§ 3 Leistungsumfang</h2>
                  <div className="space-y-4 text-muted-foreground">
                    <p>
                      <strong>3.1</strong> Der Berater erbringt Beratungsleistungen nach den vereinbarten Leistungsbeschreibungen. Die Beratung erfolgt nach bestem Wissen und Gewissen auf Grundlage der vom Auftraggeber zur Verfügung gestellten Informationen.
                    </p>
                    <p>
                      <strong>3.2</strong> Der Berater ist berechtigt, zur Erfüllung seiner Vertragspflichten geeignete Dritte (Subunternehmer) einzusetzen.
                    </p>
                    <p>
                      <strong>3.3</strong> Die Beratungsleistungen umfassen keine Rechtsberatung im Sinne des Rechtsberatungsgesetzes. Bei rechtlichen Fragen wird auf entsprechende Fachkräfte verwiesen.
                    </p>
                  </div>
                </section>

                <section>
                  <h2 className="text-2xl font-semibold mb-4 text-primary">§ 4 Mitwirkungspflichten des Auftraggebers</h2>
                  <div className="space-y-4 text-muted-foreground">
                    <p>
                      <strong>4.1</strong> Der Auftraggeber verpflichtet sich, alle für die Beratung notwendigen Informationen vollständig und wahrheitsgemäß zur Verfügung zu stellen.
                    </p>
                    <p>
                      <strong>4.2</strong> Änderungen der für die Beratung relevanten Verhältnisse sind dem Berater unverzüglich mitzuteilen.
                    </p>
                    <p>
                      <strong>4.3</strong> Der Auftraggeber stellt den Berater von allen Ansprüchen Dritter frei, die auf unvollständigen oder unrichtigen Angaben des Auftraggebers beruhen.
                    </p>
                  </div>
                </section>

                <section>
                  <h2 className="text-2xl font-semibold mb-4 text-primary">§ 5 Vergütung und Zahlungsbedingungen</h2>
                  <div className="space-y-4 text-muted-foreground">
                    <p>
                      <strong>5.1</strong> Die Vergütung richtet sich nach der jeweiligen Vereinbarung. Alle Preise verstehen sich zuzüglich der gesetzlichen Mehrwertsteuer.
                    </p>
                    <p>
                      <strong>5.2</strong> Rechnungen sind innerhalb von 14 Tagen nach Rechnungsdatum ohne Abzug zur Zahlung fällig.
                    </p>
                    <p>
                      <strong>5.3</strong> Bei Zahlungsverzug werden Verzugszinsen in Höhe von 9 Prozentpunkten über dem Basiszinssatz berechnet.
                    </p>
                  </div>
                </section>

                <section>
                  <h2 className="text-2xl font-semibold mb-4 text-primary">§ 6 Geheimhaltung und Datenschutz</h2>
                  <div className="space-y-4 text-muted-foreground">
                    <p>
                      <strong>6.1</strong> Der Berater verpflichtet sich, alle ihm im Rahmen der Beratungstätigkeit bekannt gewordenen Geschäfts- und Betriebsgeheimnisse vertraulich zu behandeln.
                    </p>
                    <p>
                      <strong>6.2</strong> Die Verarbeitung personenbezogener Daten erfolgt gemäß den Bestimmungen der DSGVO. Einzelheiten regelt unsere Datenschutzerklärung.
                    </p>
                    <p>
                      <strong>6.3</strong> Die Geheimhaltungsverpflichtung besteht auch nach Beendigung des Vertragsverhältnisses fort.
                    </p>
                  </div>
                </section>

                <section>
                  <h2 className="text-2xl font-semibold mb-4 text-primary">§ 7 Haftung</h2>
                  <div className="space-y-4 text-muted-foreground">
                    <p>
                      <strong>7.1</strong> Der Berater haftet nur bei Vorsatz und grober Fahrlässigkeit. Die Haftung für leichte Fahrlässigkeit ist ausgeschlossen, soweit nicht Schäden aus der Verletzung des Lebens, des Körpers oder der Gesundheit oder aus der Verletzung einer wesentlichen Vertragspflicht resultieren.
                    </p>
                    <p>
                      <strong>7.2</strong> Bei der Verletzung wesentlicher Vertragspflichten durch leichte Fahrlässigkeit ist die Haftung auf den bei Vertragsschluss vorhersehbaren, vertragstypischen Schaden begrenzt.
                    </p>
                    <p>
                      <strong>7.3</strong> Die Haftung nach dem Produkthaftungsgesetz bleibt unberührt.
                    </p>
                  </div>
                </section>

                <section>
                  <h2 className="text-2xl font-semibold mb-4 text-primary">§ 8 Kündigung</h2>
                  <div className="space-y-4 text-muted-foreground">
                    <p>
                      <strong>8.1</strong> Beide Parteien können den Beratungsvertrag jederzeit ohne Einhaltung einer Frist kündigen.
                    </p>
                    <p>
                      <strong>8.2</strong> Das Recht zur fristlosen Kündigung aus wichtigem Grund bleibt unberührt.
                    </p>
                    <p>
                      <strong>8.3</strong> Bei Kündigung durch den Auftraggeber sind bereits erbrachte Beratungsleistungen zu vergüten.
                    </p>
                  </div>
                </section>

                <section>
                  <h2 className="text-2xl font-semibold mb-4 text-primary">§ 9 Urheberrecht</h2>
                  <div className="space-y-4 text-muted-foreground">
                    <p>
                      <strong>9.1</strong> Alle vom Berater erstellten Konzepte, Analysen, Gutachten und sonstigen Arbeitsergebnisse bleiben geistiges Eigentum des Beraters.
                    </p>
                    <p>
                      <strong>9.2</strong> Der Auftraggeber erhält ein einfaches Nutzungsrecht für den vereinbarten Verwendungszweck.
                    </p>
                  </div>
                </section>

                <section>
                  <h2 className="text-2xl font-semibold mb-4 text-primary">§ 10 Widerrufsrecht</h2>
                  <div className="space-y-4 text-muted-foreground">
                    <p>
                      <strong>10.1</strong> Verbrauchern steht bei Verträgen, die außerhalb von Geschäftsräumen oder als Fernabsatzverträge geschlossen werden, ein Widerrufsrecht zu.
                    </p>
                    <p>
                      <strong>10.2</strong> Das Widerrufsrecht beträgt 14 Tage ab Vertragsschluss. Die Einzelheiten ergeben sich aus der separaten Widerrufsbelehrung.
                    </p>
                  </div>
                </section>

                <section>
                  <h2 className="text-2xl font-semibold mb-4 text-primary">§ 11 Schlussbestimmungen</h2>
                  <div className="space-y-4 text-muted-foreground">
                    <p>
                      <strong>11.1</strong> Es gilt das Recht der Bundesrepublik Deutschland unter Ausschluss des UN-Kaufrechts.
                    </p>
                    <p>
                      <strong>11.2</strong> Erfüllungsort und Gerichtsstand für alle Streitigkeiten aus dem Vertragsverhältnis ist München, sofern der Auftraggeber Vollkaufmann, juristische Person des öffentlichen Rechts oder öffentlich-rechtliches Sondervermögen ist.
                    </p>
                    <p>
                      <strong>11.3</strong> Sollten einzelne Bestimmungen dieser AGB unwirksam sein oder werden, berührt dies die Wirksamkeit der übrigen Bestimmungen nicht.
                    </p>
                  </div>
                </section>

                <section className="bg-muted/30 p-6 rounded-lg">
                  <h2 className="text-xl font-semibold mb-4 text-primary">Kontakt</h2>
                  <div className="space-y-2 text-muted-foreground">
                    <p><strong>RPI GmbH</strong></p>
                    <p>Gotthelfstraße 36</p>
                    <p>81677 München</p>
                    <p>Deutschland</p>
                    <p className="mt-3">
                      Telefon: 08962824646<br />
                      E-Mail: <a href="mailto:info@renteplusimmobilie.de" className="text-accent hover:underline">info@renteplusimmobilie.de</a>
                    </p>
                  </div>
                </section>

                <div className="pt-8 border-t">
                  <h2 className="text-xl font-semibold mb-4 text-primary">Kostenlose Erstberatung</h2>
                  <p className="text-muted-foreground mb-6">
                    Vereinbaren Sie jetzt Ihren kostenlosen und unverbindlichen Beratungstermin zur Immobilienverrentung.
                  </p>
                  <a
                    href="https://calendly.com/renteplusimmobilie/20min"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-block bg-accent hover:bg-accent/90 text-accent-foreground px-6 py-3 rounded-lg font-medium transition-colors"
                  >
                    Beratungstermin vereinbaren
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AGB;